import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 6h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 18h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 15v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 12h-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 12H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 9-.88.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.88 14.12 9 15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 15-.88-.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.88 9.88 9 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ServerCog";
const ServerCog = memo(themed(Icon));
export {
  ServerCog
};
//# sourceMappingURL=server-cog.js.map
